import React from 'react';
import Lang from '@components/Lang/Lang';
import {Input, Tabs, Form, Row, Col, message, Modal,} from 'antd';
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import FetchTable from '@components/FetchTable/FetchTable';
import CustomerService from "@services/CustomerInvoiceService";
import { isEmpty } from '../../../utils/utils';
import './index.less';
import PayListViewPayment from "@components/PayListViewPayment/PayListViewPayment";

const { Search } = Input;
/**
 * 凭证
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
class CustomerInvoice extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            statusKey: '0',
            loading: false,
            listQuery:{}, // 搜索Map
            list: [],
            // 表格
            columns:[
                {
                    cnTitle: '凭证类型',
                    dataIndex: 'typeName',
                    cnTitleId: 'PingZhengLeiXing',
                },
                {
                    cnTitle: ['PO单号','集柜单号'],
                    dataIndex: 'fromBizCode',
                    cnTitleId: ['PODanHao','JiGuiDanHao'],
                },
                {
                    cnTitle: '应付总金额',
                    dataIndex: 'amount',
                    cnTitleId: 'YingFuZongJinE',
                    type:'money',
                },
                {
                    cnTitle: '付款凭证生成时间',
                    dataIndex: 'createTime',
                    cnTitleId: 'FuKuanPingZhengShengChengShiJian',
                    type:'timestampToDate'
                },
                {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    width: 200,
                    cnTitleId: 'CaoZuo',
                    render: (item = {}, record) => {
                       return (<div>
                            {/*<span className="btnView" onClick={() => this.handleViewFile(record.invoiceFileUrl)}>*/}
                                    {/*{Lang({id: 'ChaKanFuKuanPingZheng', default: '查看付款凭证'})}*/}
                                {/*</span>*/}
                            {/* 查看凭证按钮 有凭证文件才显示 invoiceFileId */}
                            {!isEmpty(record.invoiceFileUrl)&&<PayListViewPayment record={record} />}
                        </div>)
                    }
                }
            ],
            pageSize:10,
        }

    }
    /**
     * 查看
     * 打开文件
     * **/
    // handleViewFile(invoiceFileUrl=''){
    //     const sType = invoiceFileUrl.length>4?invoiceFileUrl.substr(invoiceFileUrl.length-4,invoiceFileUrl.length):'';
    //     if(sType.indexOf('pdf')!= -1){
    //         window.open(invoiceFileUrl,'_blank')
    //     }else this.popPicShow(invoiceFileUrl)
    // }
    /**
     * 图片
     ***/
    // popPicShow(picList){
    //     this.setState({
    //         showPicPop:true,
    //         picList:picList,
    //     })
    // }
    /**
     * （切换）
     *
     * @param {Object} options 查询参数
     */
    tabsOnChange(key) {
        this.setState({
            statusKey: key,
        })
        this.onSearch(this.state.listQuery,key,this.state.pageSize)
    }
    /**
     * （查询）
     *
     * @param {Object} options 查询参数
     */
    getList(listQuery,callback){
        CustomerService.getInvoiceList(listQuery).then(resp =>callback(resp));
    }
    // 调用 查询 模型/表格组件的方法
    onPageTemplateTableRef = (ref) => this.onPageTemplateTableChild = ref;
    /**
     * 搜索事件
     * searchMap 搜索条件
     * tabKey 当前tabkey
     * pageSize 页数
     * pageIndex 页码
     * **/
    onSearch(searchMap={},tabKey,pageSize,pageIndex=1){
        if(this.onPageTemplateTableChild){
            const pagingQuery = {
                pageIndex: pageIndex,
                pageSize: pageSize
            }
            let send = {
                status:tabKey,
                pagingQuery:pagingQuery,
            }
            for(let key in searchMap){ // 新增判断是否有值才发送搜索
                if(!isEmpty(searchMap[key]))send[key]= searchMap[key];
            } 
            this.onPageTemplateTableChild.handleFetch(send);
        }
    }
    /**
     * 行编事件
     * **/
    changeFile = ({ target: { value } }, field ) => {
        value = value.trim();
        let newFieldList = {...this.state.listQuery};
        newFieldList[field] = value ? value : "";
        this.setState({
            listQuery: newFieldList,
        });
    };
    init(){
        const {location} = this.props;
        let sSearch = location.search||'';
        if(!isEmpty(sSearch)){
            sSearch = sSearch.substring(4, sSearch.length);
            const buyerId ={
                buyerId:sSearch
            }
            this.setState({listQuery:buyerId})
            this.onSearch(buyerId,this.state.statusKey,this.state.pageSize)
        }
    }
    /**
     * 关闭弹窗
     *
     **/
    handleCancelPop(){
        this.setState({
            showModal:false,
            showPicPop:false,
            title:{},
            fromInitialValues:{}
        })
    }
    componentDidMount() {
        this.init()
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render() {
        const {loading, statusKey, columns,listQuery, pageSize,showPicPop,picList} = this.state;
        return (
            <div>
                <CommonBreadcrumb list={[
                    {link:'/customer/list',name: Lang({id: 'KeHuXinXi', default: '客户信息'})},
                    {name: Lang({id: 'FuKuanPingZheng', default: '付款凭证'})},
                ]}></CommonBreadcrumb>
                <div className="customer-screen">
                    <Tabs defaultActiveKey="wait" onChange={this.tabsOnChange.bind(this)}
                          items={[
                              {
                                  key: '0',
                                  label:(<div><span className="mr_4">{Lang({id: 'WeiFuKuanPingZheng', default: '未付款凭证'})}</span>
                                      {/*<Badge count={this.state.waitIntoNum}></Badge>*/}
                                  </div>),
                              },
                              {
                                  key: '1',
                                  label:(<div><span className="mr_4">{Lang({id: 'YiFuKuanPingZheng', default: '已付款凭证'})}</span></div>),
                              },
                          ]}
                    />
                    <Form layout="inline">
                        <Row style={{ width: "100%" }}>
                            <Col span={7}>
                                <Form.Item label="">
                                    <Search
                                        placeholder={ Lang({id: "QingShuRuPODanHaoHuoZheJiGuiDanHao",default: "请输入PO单号或者集柜单号",})}
                                        style={{ width: "100%" }}
                                        loading={loading}
                                        value = {listQuery.customer}
                                        onChange={(e)=>this.changeFile(e,'keyword')}
                                        onSearch={()=>this.onSearch(listQuery,statusKey,pageSize)}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    <FetchTable columns={columns}
                                    initFetch={false}
                                    fetchCondition={listQuery}
                                    pageSize={pageSize}
                                    onRef={this.onPageTemplateTableRef}
                                    fetchFunction={this.getList} />
                </div>
                {showPicPop&&<Modal
                    title={ Lang({id: "HeTongWenJian",default: "合同文件",})}
                    centered
                    open={showPicPop}
                    onOk={() => this.handleCancelPop()}
                    onCancel={() => this.handleCancelPop()}
                    width={1000}
                >
                    <div className={'pop-contract-img'} key={picList}>
                        <img src={picList} />
                    </div>
                </Modal>}
            </div>
        )
    }
}

export default CustomerInvoice;
